<app-breadcrumb [styleBreadcrumb]="'page-heading'" [title]="'USERS'" [breadcrumb]="''" [count]="count"
  icon="fa-users-cog">
</app-breadcrumb>
<div class="content-background">
  <div class="row">
    <div class="col-auto d-flex flex-nowrap align-items-center">
      <button appPreventClick kendoButton [primary]="false" type="button" (click)="showOnlineUsers()"
        [disabled]="loadingOnlineUsers">
        {{'ONLINE-USERS' | translate}}<i class="far fa-sign-in-alt" *ngIf="!loadingOnlineUsers"
          style="width:18px"></i><i class="k-icon k-i-loading" *ngIf="loadingOnlineUsers" style="width:18px"></i>
      </button>
      <button appPreventClick kendoButton [primary]="false" type="button" class="ml-3" *ngIf="isOperator"
        (click)="disableUsers()" [disabled]="!allowDisableUsers">
        {{'MAINTENANCE-MODE' | translate}}
      </button>
      <button appPreventClick kendoButton [primary]="false" type="button" class="ml-3" *ngIf="isOperator"
        (click)="enableUsers()" [disabled]="!allowEnableUsers">
        {{'END-MAINTENANCE-MODE' | translate}}
      </button>
    </div>
    <div class="col">
      <div class="inputWithIcon inputWithIcon-search float-right d-flex">
        <app-advanced-mode id="usersGridAdvancedSwitch" [storageKey]="'users-list'"
          (collapsibleToggle)="enableAdvanced=$event">
        </app-advanced-mode>
        <input #search kendoTextBox class="ml-4 button-search" placeholder="{{ 'SEARCH-NAME' | translate }}"
          (keyup)="searchFieldChange(search.value)" title="{{ 'SEARCH-NAME' | translate }}" />
        <i class="fa fa-search fa-lg fa-fw fa-search-icon"></i>
      </div>
    </div>
  </div>
  <div class="mt-3">
    <kendo-grid #grid [data]="gridView" [loading]="loading" [navigable]="true"
      [pageable]="total > state.take ? { buttonCount: 5, pageSizes: pageSizes} : false" [pageSize]="state.take"
      [skip]="state.skip" [sortable]="true" [sort]="state.sort" [filterable]="enableAdvanced" [filter]="state.filter"
      [selectable]="{ mode: 'single' }" [columnMenu]="enableAdvanced" [resizable]="true" [reorderable]="enableAdvanced"
      (dataStateChange)="dataStateChange($event)">
      <kendo-grid-messages noRecords="{{ 'NO-USERS' | translate }}">
      </kendo-grid-messages>
      <kendo-grid-column field="name" title="{{ 'NAME' | translate }}" [width]="15"></kendo-grid-column>
      <kendo-grid-column field="organizationName" title="{{ 'ORGANIZATION' | translate }}" [width]="15">
      </kendo-grid-column>
      <kendo-grid-column field="departmentName" title="{{ 'DEPARTMENT' | translate }}" [width]="17" [hidden]="true">
      </kendo-grid-column>
      <kendo-grid-column field="email" title="{{ 'EMAIL' | translate }}" [width]="20"></kendo-grid-column>
      <kendo-grid-column field="roleName" title="{{ 'USER-ROLE' | translate }}" [width]="13">
        <ng-template kendoGridFilterCellTemplate let-filter>
          <app-dropdown-filter [filter]="filter" [data]="userRoles" filterField="roleName"
            selectDefaultText="{{ 'SELECT-ROLE' | translate }}" textField="text" valueField="value">
          </app-dropdown-filter>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="allowedRolesText" title="{{ 'ACTIVE-ROLES' | translate }}" [width]="17"
        [sortable]="false" [filterable]="false" class="ellipsis-text">
      </kendo-grid-column>
      <kendo-grid-column class="text-center" field="servicesAccount" [width]="10"
        title="{{ 'SERVICES-ACCOUNT' | translate }}" filter="boolean">
        <ng-template kendoGridCellTemplate let-dataItem>
          <i *ngIf="dataItem.servicesAccount" class="fas fa-check"></i>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column class="text-center" field="enabled" [width]="10" title="{{ 'ACCOUNT-ENABLED' | translate }}"
        filter="boolean">
        <ng-template kendoGridCellTemplate let-dataItem>
          <i *ngIf="dataItem.enabled" class="fas fa-check"></i>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column class="text-center" field="temporarilyDisabled" [width]="12" title="{{ 'MAINTENANCE-MODE' | translate }}"
        filter="boolean">
        <ng-template kendoGridCellTemplate let-dataItem>
          <i *ngIf="dataItem.temporarilyDisabled" class="fas fa-check"></i>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="lastLoggedOn" [width]="20" title="{{ 'LAST-LOGIN' | translate }}" filter="date"
        format="{0:g}">
      </kendo-grid-column>
      <kendo-grid-column field="createdBy" [width]="20" title="{{ 'CREATED-BY' | translate }}" [hidden]="true">
      </kendo-grid-column>
      <kendo-grid-column field="createdOn" [width]="20" title="{{ 'CREATED-DATE' | translate }}" filter="date"
        format="{0:g}" [hidden]="true"></kendo-grid-column>
      <kendo-grid-column field="lastModifiedBy" [width]="20" title="{{ 'LAST-MODIFIED-BY' | translate }}"
        [hidden]="true">
      </kendo-grid-column>
      <kendo-grid-column field="lastModifiedOn" [width]="20" title="{{ 'LAST-MODIFIED-DATE' | translate }}"
        filter="date" format="{0:g}" [hidden]="true"></kendo-grid-column>
      <kendo-grid-command-column [width]="15" title="{{ 'ACTIONS' | translate }}" class="text-center">
        <ng-template kendoGridCellTemplate let-dataItem>
          <i class="fas fa-edit fa-lg" title="{{ 'EDIT' | translate }}" (click)="editHandler(dataItem)">
          </i>
          &nbsp;
          <i class="fas fa-trash-alt fa-lg" title="{{ 'DELETE' | translate }}" (click)="deleteHandler(dataItem)"
            [ngClass]="{'extra-padding': !canResendRegistration(dataItem)}">
          </i>
          &nbsp;
          <i class="fas fa-envelope fa-send-document-action fa-lg mr-1"
            title="{{ 'RESEND-REGISTRATION-EMAIL' | translate }}" (click)="resendRegistrationHandler(dataItem['id'])"
            *ngIf="canResendRegistration(dataItem)">
          </i>
        </ng-template>
      </kendo-grid-command-column>
    </kendo-grid>
    <button kendoButton [primary]="false" type="button" class="float-right mt-3 mb-3" (click)="addHandler()">
      {{'ADD' | translate}}<i class="far fa-user-plus"></i>
    </button>
  </div>
</div>

<!-- User Edit form dialog -->
<kendo-dialog [width]="1200" *ngIf="editUser" (close)="editUser = false">
  <kendo-dialog-titlebar>
    <h3>{{ (isNew ? 'ADD-USER' : 'EDIT-USER') | translate }}</h3>
  </kendo-dialog-titlebar>
  <app-user-detail #userDetail [isAdmin]="true" [selectedUser]="selectedUser" (afterSave)="afterSaveHandler()">
  </app-user-detail>
  <kendo-dialog-actions>
    <button kendoButton type="button" (click)="editUser = false">
      {{ 'CANCEL' | translate}}
    </button>
    <button appPreventClick kendoButton type="button" [disabled]="!userDetail.formValid() || !userDetail.formDirty()"
      (click)="userDetail.save()">
      {{ 'SAVE' | translate}}
    </button>
  </kendo-dialog-actions>
</kendo-dialog>

<!--Confirm Resend Registration-->
<kendo-dialog title="{{ 'PLEASE-CONFIRM' | translate }}" *ngIf="resendDialogOpened" (close)="close('resendDialog')"
  [minWidth]="250" [width]="450">
  <p>{{ 'RESEND-CONFIRMATION' | translate }}</p>
  <span class="k-font-weight-bold">{{selectedUser.name}}</span>
  <kendo-dialog-actions>
    <button kendoButton (click)="resendAction(false)">{{ 'NO' | translate }}</button>
    <button appPreventClick kendoButton (click)="resendAction(true)" [primary]="true">{{ 'YES' | translate }}</button>
  </kendo-dialog-actions>
</kendo-dialog>

<!--Confirm deletion-->
<kendo-dialog title="{{ 'PLEASE-CONFIRM' | translate }}" *ngIf="deleteDialogOpened" (close)="close('deleteDialog')"
  [minWidth]="250" [width]="450">
  <p>{{ 'CONFIRM-DELETION' | translate }}</p>
  <span *ngIf="selectedUser.name" class="k-font-weight-bold">{{selectedUser.name}}</span>
  <span *ngIf="!selectedUser.name" class="k-font-weight-bold">{{selectedUser.username}}</span>
  <kendo-dialog-actions>
    <button kendoButton (click)="deleteAction(false)">{{ 'NO' | translate }}</button>
    <button appPreventClick kendoButton (click)="deleteAction(true)" [primary]="true">{{ 'YES' | translate }}</button>
  </kendo-dialog-actions>
</kendo-dialog>

<!--Online users-->
<app-user-online [dialogOpened]="onlineUsersDialogOpened" (loading)="onlineUsersLoadingChange($event)"
  (closing)="onlineUsersDialogOpened=false;">
</app-user-online>

<!-- Disable users -->
<kendo-dialog *ngIf="disableUsersDialogOpened" (close)="closeTemporarilyDisableUsers()" [minWidth]="450" [width]="900">
  <kendo-dialog-titlebar>
    <h3>{{'MAINTENANCE-MODE' | translate}}</h3>
  </kendo-dialog-titlebar>
  <form *ngIf="temporarilyDisableUsersForm" [formGroup]="temporarilyDisableUsersForm">
    <div class="p-2">
      <div class="form-group pl-1 pr-1">
        <label for="excludedUsers" class="k-form-field mt-0 w-100">
          <span class="k-text-uppercase dark">
            {{ 'EXCLUDED-USERS' | translate }}
          </span>
          <kendo-multiselect [data]="usersFiltered" formControlName="excludedUsers"
            class="max-height w-100" [textField]="'name'" [filterable]="true" [valueField]="'id'"
            (filterChange)="filterUsers($event)" (close)="searchTerm=''" [autoClose]="true"
            (removeTag)="onExcludedUserRemove($event)"
            [virtual]="virtualUser" [itemDisabled]="excludedUsersItemDisabled">
            <ng-template kendoMultiSelectItemTemplate let-dataItem>
              <span innerHTML="{{ dataItem.name | highlight : searchTerm }}">
              </span>
            </ng-template>
          </kendo-multiselect>
        </label>
      </div>
      <div>{{'MAINTENANCE-MODE-NOTE' | translate}}</div>
    </div>
  </form>
  <kendo-dialog-actions>
    <button kendoButton type="button" (click)="closeTemporarilyDisableUsers()">{{ 'CANCEL' | translate }}</button>
    <button appPreventClick kendoButton type="button" (click)="disableUsersAction()"
      >{{'SAVE' | translate}}
    </button>
  </kendo-dialog-actions>
</kendo-dialog>

<!--Enable Users-->
<kendo-dialog title="{{ 'PLEASE-CONFIRM' | translate }}" *ngIf="enableUsersDialogOpened" (close)="close('enableUsersDialog')"
  [minWidth]="250" [width]="450">
  <p>{{ 'CONFIRM-MAINTENANCE-MODE-END' | translate }}</p>  
  <kendo-dialog-actions>
    <button kendoButton (click)="close('enableUsersDialog')">{{ 'NO' | translate }}</button>
    <button appPreventClick kendoButton (click)="enableUsersAction(true)" [primary]="true">{{ 'YES' | translate }}</button>
  </kendo-dialog-actions>
</kendo-dialog>